import {Patient} from '@cypro/engine/schema'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {Box, Button, Text, VStack} from '@chakra-ui/react'
import {useCan} from '@/shared/hooks/use-permissions'
import {useTranslate} from '@tolgee/react'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {dialog} from '@cypro/ui/components'
import {useMemo} from 'react'
import {InsuranceDetailsDialog} from '../../dialogs/insurance-details-dialog'
import {isPendingHl7Import} from '@/modules/patients/functions'

export function Insurance({patient}: {patient: Patient}) {
  const {t} = useTranslate('common')
  const canEditPatient = useCan('patients.edit')

  const insuranceItems = useMemo(() => {
    return [
      {label: t('policy_number'), value: patient.insurance?.policyNumber || '-'},
      {label: t('insurance_number'), value: patient.insurance?.insuranceNumber || '-'},
      {label: t('private_patient'), value: patient.insurance?.privatePatient ? t('yes') : t('no')},
    ]
  }, [t, patient])
  return (
    <Box rounded="md" borderWidth="1px" padding="4">
      <DataSection
        label={
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            <VStack align="flex-start">
              {t('insurance')}
              <Text fontSize="sm" color="fg.muted">
                {patient.insurance ? patient.insurance?.insuranceCompany?.name : `(${t('no_insurance_assigned')})`}
              </Text>
            </VStack>
            <Button
              variant="ghost"
              colorPalette="cyan"
              disabled={!canEditPatient || isPendingHl7Import(patient)}
              onClick={async () => {
                await dialog.open('insurance-dialog', {
                  children: <InsuranceDetailsDialog patientId={patient.id} insurance={patient.insurance} />,
                })
              }}
            >
              {t('edit')}
            </Button>
          </Box>
        }
      >
        <DataList items={insuranceItems} />
      </DataSection>
    </Box>
  )
}
